module.exports = __webpack_public_path__ + "img/9788952747891.517a764f.jpg";